import React from 'react'
import { ReactElement, ReactNode } from 'react'

export const convertChildrenToElementsArray = (children: ReactNode): ReactElement[] => {
    const mapped =
        React.Children.map(children, (child) => {
            const isValidElement = React.isValidElement(child)
            if (!isValidElement) return null

            const isFragment = isValidElement && child.type === React.Fragment

            return isFragment
                ? (child as React.ReactElement<{ children?: ReactNode }>).props.children
                : child
        })?.filter((child) => child !== null) ?? []
    return mapped as ReactElement[]
}
